<script lang="ts">
  import { createEventDispatcher } from 'svelte';

  import Button from '$components/ui/button.svelte';

  import { t } from '$lib/i18n';

  export let total: number | null;
  export let showing: number;
  export let hasNextPage: boolean | undefined;
  export let loading: boolean;

  const dispatch = createEventDispatcher<{ loadMore: undefined }>();
</script>

<div class="flex flex-col items-center">
  {#if total}
    <p class="mt-11 w-full text-center text-md text-primary/40 transition-opacity">
      {$t('showing-x-of-y', { x: `${showing}`, y: `${total}` })}
    </p>
  {/if}

  {#if hasNextPage}
    <Button
      name="load-more"
      type="button"
      variant="ghost"
      class="mt-4 w-fit"
      {loading}
      on:click={() => dispatch('loadMore')}
    >
      {$t('products.show-more')}
    </Button>
  {/if}
</div>
